const commonParticulars: {
  [key: string]: {
    key: string;
    description: string;
  };
} = {
  fee: {
    key: 'managementfee',
    description: 'Fixed Management Fees based on AUM',
  },
  charges: {
    key: 'charges',
    description: 'Custodian Fees, Depository Charges & Fund Accounting Charges',
  },
  taxes: {
    key: 'taxes',
    description: 'Goods and Service Tax, Security Transaction Tax & Other Statutory levies',
  },
};

export const particulars: {
  [key: string]: {
    [key: string]: {
      key: string;
      description: string;
    };
  };
} = {
  Fixed: {
    ...commonParticulars,
  },
  Variable: {
    ...commonParticulars,
    performanceFee: {
      key: 'performanceFee',
      description: 'Performance Based Management Fees -Variable Fees (at the end of tenure)',
    },
  },
};
